// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Autocomplete,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain';
import MsiDatagridCheckbox from '../../../../components/custom/MsiDatagridAutoCheckbox';
import { useToast } from '../../../../components/ToastProvider';
import moment from 'moment';
import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [mode, setMode] = useState<string>("")
    const [listData, setListData] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [valBarang, setValBarang] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])

    useEffect(() => {
        getDetail()
        getData("barang-jadi")
        getBarang("barang-jadi")
    }, [])

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/production/work-order-simple/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setValue('tgl', data?.tgl)
                    setValue('keterangan', data?.keterangan)
                    setValue('pic', data.pic)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getData = (mode: any) => {
        let url = apiUrl.apiUrl + `/production/work-order-simple/detail-barang/${id}/${mode}`

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getBarang = (mode: any) => {
        let url = apiUrl.apiUrl + `/production/work-order-simple/list-barang/${mode}`

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data.map(item => ({
                        ...item,
                        nama: `${item.kode} - ${item.nama_barang}`
                    }))
                    setListBarang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        switch (newValue) {
            case "0":
                setMode("barang-jadi")
                getData("barang-jadi")
                break;
            case "1":
                setMode("bahan-baku")
                getData("bahan-baku")
                break;
            default:
                break;
        }
    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        tgl: any,
        keterangan: any,
        pic: any,

        mmbarang_id: any,
        keterangan_detail: any,
        qty: any
    }

    const defaultValues = {
        syscabang_id: 1,
    }

    const {
        control,
        handleSubmit,
        resetField,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const formatNumber = (value: string | number) => {
        if (!value) return "";

        const str = String(value);

        // split decimal
        const [int, dec] = str.replace(/\./g, "").split(",");

        const formattedInt = Number(int || 0).toLocaleString("id-ID");

        return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
    };

    const parseNumber = (value: string) => {
        return value.replace(/\./g, "");
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + `/production/work-order-simple/detail-delete/${row.id}/${mode}`
        axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    getData(mode)
                    showToast("Data berhasil dihapus", "success")
                } else {
                    showToast(response.data.message, "error")
                }
            })
            .catch(error => {
                showToast(error.message, "error")
            })
    };

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"Hapus"} title={"Hapus"} placement="top">
                    <IconButton onClick={() => onDelete(row)}>
                        <Icon icon={"mdi:trash"} color={"red"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 70,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => navigate('/production/work-order-simple')}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail WO Simple
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Tgl. Dokumen : <b>{moment(getValues('tgl')).locale('id').format('DD MMMM YYYY')}</b>
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <form onSubmit={handleSubmit((data) => {
                        // Handle form submission
                    })}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.pic && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TabContext value={tabs}>
                                    <TabList
                                        scrollButtons
                                        variant='scrollable'
                                        onChange={handleChangeTabs}
                                        aria-label='forced scroll tabs example'
                                    >
                                        <Tab value='0' label='BARANG JADI' />
                                        <Tab value='1' label='BAHAN BAKU' />
                                    </TabList>
                                    <TabPanel value='0'>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            startIcon={<Icon icon="mdi:add" />}
                                            onClick={() => {
                                                setOpenDialog(true)
                                                resetField('mmbarang_id')
                                                resetField('qty')
                                                resetField('keterangan_detail')
                                                setValBarang(null)
                                            }}
                                            sx={{ mr: 1 }}
                                        >
                                            TAMBAH DATA
                                        </Button>
                                        <MsiDatagrid array={listData} actions={actionData} />
                                    </TabPanel>
                                    <TabPanel value='1'>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            startIcon={<Icon icon="mdi:add" />}
                                            onClick={() => {
                                                setOpenDialog(true)
                                            }}
                                            sx={{ mr: 1 }}
                                        >
                                            TAMBAH DATA
                                        </Button>
                                        <MsiDatagrid array={listData} actions={actionData} />
                                    </TabPanel>
                                </TabContext>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = ''
                    if (mode == 'bahan-baku') {
                        url = apiUrl.apiUrl + '/production/work-order-simple/add-bahan-baku';
                    }
                    else {
                        url = apiUrl.apiUrl + '/production/work-order-simple/add-barang-jadi';
                    }

                    axios.post(url, {
                        id: id,
                        mmbarang_id: data.mmbarang_id,
                        qty: data.qty,
                        keterangan: data.keterangan_detail,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialog(false);
                                getData(mode);
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Data {mode == 'bahan-baku' ? 'Bahan Baku' : 'Barang Jadi'}
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => {
                                            return (
                                                <Autocomplete
                                                    {...field}
                                                    options={listBarang}
                                                    value={listBarang.find(item => item.id === field.value) || null}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}

                                                    onChange={(event, newValue) => {
                                                        field.onChange(newValue ? newValue.id : null)
                                                        setValue('mmbarang_id', newValue ? newValue.id : null)
                                                    }}

                                                    getOptionLabel={(option) => option?.nama || ''}

                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label='Barang'
                                                            InputLabelProps={{ shrink: true }}
                                                            error={Boolean(errors.mmbarang_id)}
                                                        />
                                                    )}
                                                />
                                            )
                                        }}
                                    />

                                    {errors.mmbarang_id && (
                                        <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>

                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                label="Quantity"
                                                fullWidth
                                                value={formatNumber(field.value || "0")}
                                                inputProps={{ inputMode: "numeric" }}
                                                onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                                error={!!errors.qty}
                                                helperText={errors.qty?.message as string}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.qty && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_detail'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan_detail && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <FloatingJurnalButton
                id={Number(id)}
                tabel="wo_order"
            />
        </Grid>
    )
}
